var map = {
	"./Agent_Wilkes.png": 6496,
	"./Ash_Harding.png": 1347,
	"./Baddest_Santa.png": 4156,
	"./Captian_Wiggins.png": 7428,
	"./ChickenNator.png": 8294,
	"./Chopper_Harris.png": 2893,
	"./Commando_Chicken.png": 2451,
	"./Corporal_Lewis.png": 8251,
	"./Custom_Character.png": 6489,
	"./DAR.png": 4176,
	"./DJ_Scully.png": 7759,
	"./Dave_The_Butcher_Roberts.png": 4535,
	"./Dr_Gary_Glover.png": 3811,
	"./Dr_Jeffrey_Tamm.png": 42,
	"./FoundryWorker_Aldridge.png": 1281,
	"./Harchier_Spebbington.png": 3991,
	"./Harchier_Spebbington_II.png": 7378,
	"./Harold_Hunt.png": 1558,
	"./Harold_Lott.png": 2470,
	"./Hayato_Tanaka.png": 1590,
	"./KF_German.png": 9382,
	"./KF_Soviet.png": 6760,
	"./Kerry_Fitzpatrick.png": 7453,
	"./Kevo_Chav.png": 2361,
	"./LanceCorporal_Lee_Baron.png": 4194,
	"./Lieutenant_Masterson.png": 9840,
	"./Mike_Noble.png": 2872,
	"./Mr_Foster.png": 7792,
	"./Mr_Magma.png": 8386,
	"./Mrs_Foster.png": 9200,
	"./Ms_Clamley.png": 3601,
	"./Paramedic_Alfred_Anderson.png": 5150,
	"./Police_Constable_Briar.png": 1268,
	"./Police_Sergeant_Davin.png": 4884,
	"./Private_Schnieder.png": 6587,
	"./Pyro_Blue.png": 2827,
	"./Pyro_Red.png": 8763,
	"./Reaper.png": 3645,
	"./Reverend_Alberts.png": 507,
	"./Ricky_Vegas.png": 9634,
	"./Samuel_Avalon.png": 9685,
	"./Security_Officer_Thorne.png": 5606,
	"./Sergeant_Powers.png": 3737,
	"./Shadow_Ferret.png": 6984,
	"./Steampunk_Berserker.png": 1874,
	"./Steampunk_Commando.png": 8441,
	"./Steampunk_DJ_Scully.png": 6718,
	"./Steampunk_Demolition.png": 8616,
	"./Steampunk_Firebug.png": 9175,
	"./Steampunk_Medic.png": 559,
	"./Steampunk_MrFoster.png": 2922,
	"./Steampunk_Mrs_Foster.png": 4159,
	"./Steampunk_Sharpshooter.png": 8571,
	"./Steampunk_Support_Specialist.png": 6291,
	"./Trooper_Clive_Jenkins.png": 3031,
	"./Voltage.png": 2798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8592;